import { useMsal } from "@azure/msal-react";
import { AppInsightsContext, ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { useEffect, useState } from "react";

export default function AppInsightHOC({ children }: { children: JSX.Element }) {
  const { accounts } = useMsal();
  const [reactPlugin, setReactPlugin] = useState<ReactPlugin>();

  useEffect(() => {
    const oid = accounts[0]?.idTokenClaims?.oid;
    const reactPlugin = initAppInsights(oid || "");
    setReactPlugin(reactPlugin);
  }, [accounts]);

  if (reactPlugin) {
    return <AppInsightsContext.Provider value={reactPlugin}>{children}</AppInsightsContext.Provider>;
  } else return null;
}

function initAppInsights(userLocalAccountId: string) {
  const reactPlugin = new ReactPlugin();
  if (process.env.APP_INSIGHT_CONNECTION_STRING) {
    const appInsights = new ApplicationInsights({
      config: {
        enableAutoRouteTracking: false,
        connectionString: process.env.APP_INSIGHT_CONNECTION_STRING,
        extensions: [reactPlugin],
      },
    });
    appInsights.loadAppInsights();
    appInsights.setAuthenticatedUserContext(userLocalAccountId, undefined, true);
  }
  return reactPlugin;
}
